export const SET_AVAILABILITY_CATALOGUE = 'set_availability_catalogue';
